<template>
  <div class="maincontainer" v-observe-visibility="visibilityChange">
    <table>
      <thead class="border-bottom: 1px solid rgba(0,0,0,0.12);">
        <tr>
            <th v-on:click="set_order('date')">
              <span>{{$t('interventions.date')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
            </th>
            <th v-on:click="set_order('kinds')">
              <span>{{$t('interventions.types')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'kinds' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'kinds' && order == 'asc'">arrow_drop_up</i>
               <selector  v-model="selected_kinds" :items="kinds" identifier="intervention_types"></selector>
            </th>
            <th>
              <span>{{$t('interventions.protocol')}}</span>
              
            </th>
            <th>
            
            </th>
        
        </tr>
      </thead>

      <tbody v-if="loaded">
        <template  v-for="(customer, index) in listItems">
        <tr >
          <td>{{customer.date | formatDate}}</td>
           <td>{{name_kinds(customer.types)}}</td>
          <td><a :href='"/customers/"+customer_id+"/places/"+place_id+"/interventions/"+customer.id+"/v2.pdf"'><span class="material-icons dp6">featured_play_list</span></a></td>
        </tr>
       
        </template>
         <template v-if="listItems.length == 0">
            <tr>
                <td colspan="3" style="text-align: center;">{{$t('interventions.no_protocols')}}</td>
            </tr>
        </template>
      </tbody>
      <preloader v-if="loaded == false" n="7"/>
    </table>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters';
import LineChart from './linechart.vue';
import axios from 'axios';
export default {
  data: function () {
    return {
      order: 'desc',
      orderby: 'date',
      places: [],
      loaded: false,
      datacollection: [],
      devcats: {},
      visible: false,
      kinds: [
        {name: this.$t('interventions.disinsection'), value: "disinsection"},
        {name: this.$t('interventions.disinfection'), value: "disinfection"},
        {name: this.$t('interventions.deratization'), value: "deratization"},
        {name: this.$t('interventions.other'), value: "other"}
      ],
      selected_kinds: ["disinsection", "disinfection", "deratization", "other"],
    }
  },
  props: {customer_id: [String, Number], place_id: [String, Number]},
  created() {
    this.fetch_places();
  },
  methods: {
    fetch_places: async function(){
      if(this.place_id != 0){
        var response = await axios.get('/customers/'+this.customer_id+'/places/'+this.place_id+'/interventions.json')
        this.inspections = response.data;
        this.loaded = true
      }
    },
    collapse : function(customer){
      customer.collapsed = !(customer.collapsed);
      this.$forceUpdate();
    },
    
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 'desc'){
          this.order = 'asc'
        }else if(this.order == 'asc'){
          this.order = 'desc'
        }
        
      }else{
        this.orderby = order;
      }
    },
    visibilityChange(evt, hidden){
      this.visible = evt;
    },
    name_kinds: function(kinds){
      var out = ""
      for (var i = kinds.length - 1; i >= 0; i--) {
        out+={"disinsection": this.$t('interventions.disinsection'), "disinfection": this.$t('interventions.disinfection'), "deratization": this.$t('interventions.deratization'), "other": this.$t('interventions.other') }[kinds[i]]+" "
      }
      return out;
    }
},
computed: {
      listItems() {
      var that = this;
      return _.filter(
        _.orderBy(this.inspections, this.orderby, this.order),
        function(item){
          return (_.intersection(that.selected_kinds, item.types).length > 0 || that.selected_kinds.length == 0)
        }
      );
    },
    lastInspection: function(){
      var inps = _.last(_.orderBy(this.inspections, 'date'));
      if(_.isUndefined(inps) == false)
        return inps.date;
      return "-"
    },
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
  .maincontainer {
    text-align: left;
  }
p {
  font-size: 2em;
  text-align: center;
}

thead th{
  font-weight: 300;
}
thead .input-field{
  margin-top: unset;
  margin-bottom: unset;
}
</style>
